var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowishcircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 142,
    viewBox: "0 0 148 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4468_4908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.998 71.0003C147.998 78.4941 137.544 84.24 135.352 91.0005C133.079 98.0121 138.095 108.811 133.87 114.637C129.594 120.534 117.779 119.057 111.911 123.346C106.094 127.595 103.861 139.338 96.8722 141.619C90.1335 143.819 81.4724 135.702 74.0028 135.702C66.5332 135.702 57.8721 143.819 51.1334 141.619C44.1445 139.338 41.9116 127.595 36.0941 123.346C30.2166 119.057 18.4014 120.524 14.136 114.637C9.90051 108.801 14.917 98.002 12.654 91.0005C10.4612 84.24 0.0078125 78.4941 0.0078125 71.0003C0.0078125 63.5066 10.4612 57.7607 12.654 51.0002C14.927 43.9886 9.91053 33.1899 14.136 27.3637C18.4114 21.4671 30.2266 22.9438 36.0941 18.6544C41.9116 14.4053 44.1445 2.66234 51.1334 0.382066C57.8721 -1.81785 66.5332 6.29873 74.0028 6.29873C81.4724 6.29873 90.1335 -1.81785 96.8722 0.382066C103.861 2.66234 106.094 14.4053 111.911 18.6544C117.789 22.9438 129.604 21.4771 133.87 27.3637C138.105 33.2 133.089 43.9986 135.352 51.0002C137.544 57.7607 147.998 63.5066 147.998 71.0003Z",
    fill: "#C7F760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4468_4908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 142,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowishcircular);
export default __webpack_public_path__ + "static/media/yellowishcircular.afbf0f25d793c635515b36c2aa69544d.svg";
export { ForwardRef as ReactComponent };